export default __webpack_public_path__ + "static/media/mail-bg.4d0af93d.svg";